import { ReactNode, createContext } from "react";
import { useState, useEffect } from "react";
import { Stallholder} from '@sharedtypes/Stallholder';
import localforage from "localforage";
import log from "loglevel";

const STALLHOLDER = "selected_stallholder";


export type StallholderContextValue = {
  stallholder: Stallholder | undefined;
  setStallholder: (stallholder: Stallholder | undefined) => void,
};

const StallholderContext = createContext<StallholderContextValue | undefined>(undefined);

type StallholderContextContextProps = {
  children?: ReactNode
};


export const StallholderProvider = ({ children }: StallholderContextContextProps) => {

  const [stallholder, setStallholder] = useState<Stallholder | undefined>(undefined);

  useEffect(() => {

    /*
    Cache.getItem(STALLHOLDER)
    .then(result => {
      if(result) {
        setStallholder(result);
      }
    })*/
    localforage.getItem<Stallholder>(STALLHOLDER)
    .then((value: Stallholder | null) => {
      if (value !== null) {
        console.log("Retrieved stallholder:", value);
        setStallholder(value);
      } else {
        console.log("No value found");
      }
    })
    .catch((err: unknown) => {
      console.error("Error retrieving from storage", err);
    });
    return () => {
    };
  }, []);   

  useEffect(() => {

    if (stallholder === undefined) 
      localforage.removeItem(STALLHOLDER);
      //Cache.removeItem(STALLHOLDER);
    else
      //Cache.setItem(STALLHOLDER, stallholder);
      localforage.setItem(STALLHOLDER, stallholder).then(function () {
        log.debug("Stored stallholder")
      }).catch(function (err) {
        log.error(err);
      });
    
    return () => {
    };
  }, [stallholder]);   

  return (
    <StallholderContext.Provider value={{stallholder, setStallholder}}>
      {children}
    </StallholderContext.Provider>
  );
};


export default StallholderContext;

